import { render } from "./Record.vue?vue&type=template&id=49c98cbe&scoped=true&ts=true"
import script from "./Record.vue?vue&type=script&lang=ts"
export * from "./Record.vue?vue&type=script&lang=ts"

import "./Record.vue?vue&type=style&index=0&id=49c98cbe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c98cbe"]])

export default __exports__